import React from "react";
import styles from "./styles/speech-voices.module.scss";
import { useTextToSpeechContext } from "@/components/pages/text-to-speech/components/providers/text-to-speech-provider";
import VerticalSelectVoiceInput from "@/components/common/voice-selector/inputs/vertical-select-voice-input";

const SpeechVoices = () => {
  const { settings } = useTextToSpeechContext();
  return (
    <div className={styles.wrapper}>
      <VerticalSelectVoiceInput
        modalType={{ type: "tts_voice_selector_modal" }}
      />
    </div>
  );
};

export default SpeechVoices;
